(function (historyService, $) {
  var sections = [];

  historyService.init = function () {
    var sectionElements = $("section[name]");
    $.each(sectionElements, function (index, sectionElements) {
      sections.push($(sectionElements));
    });

    handleStateChange(true);
    wireEvents();
  };

  function handleStateChange(firstLoad) {
    var State = History.getState();
    var path = el.Utils.removeBaseUrl(State.url);
    path = el.Utils.removeQueryStringFromUrl(path);
    stateChanged(path, firstLoad);
  }

  function wireEvents() {
    History.Adapter.bind(window, "statechange", function () {
      handleStateChange(false);
    });

    History.Adapter.bind(window, "anchorchange", function () {
      var path = el.Utils.removeBaseUrl(window.location.href);
      path = el.Utils.removeQueryStringFromUrl(path);
      stateChanged(path, false);
    });

    $("body").delegate("a", "click", function (event, openInNewTab) {
      handleAnchorClick(this, event, openInNewTab);
    });
  }

  function handleAnchorClick(anchorElement, event, openInNewTab) {
    if (openInNewTab === true || el.Utils.isClickEventRequestingNewTab(event)) {
      return;
    }

    anchorElement = $(anchorElement);
    var href = anchorElement.attr("href");
    var isExternalURL = el.Utils.isExternalUrl(href);

    if (isExternalURL) {
      return;
    }

    var path = el.Utils.removeBaseUrl(href);
    //path = path[(path.length > 1 ? 1 : 0)];

    var targetElement = getTargetElement(path);
    if (targetElement.length <= 0) {
      return;
    }

    if (!Modernizr.history) {
      var splitUrl = path.split("#");
      if (splitUrl.length > 1) {
        path = splitUrl[0];
      }
    }

    event.preventDefault();

    if (targetElement.length > 0) {
      scrollToElement(targetElement);
      History.pushState({}, anchorElement.text(), href);
      return;
    }

    if (!path.match("^/mw-daily")) {
      if (path === "") {
        path = "/";
      }

      History.pushState({}, "", path);
    }
  }

  // Deal with a URL change, either from the initial load, or from someone navigating via a URL
  function stateChanged(path, firstLoad) {
    if (typeof window.ga === "function") {
      window.ga("send", "pageview", path);
    }

    if (!History.enabled) {
      return false;
    }

    if (firstLoad && path.length > 1) {
      var targetElement = getTargetElement(path);
      scrollToElement(targetElement);
    }
  }

  function getTargetElement(path) {
    return $("[name='" + path.substring(1) + "']");
  }

  function scrollToElement(targetElement) {
    if (!targetElement || targetElement.length === 0) {
      return;
    }

    targetElement[0].scrollIntoView({ behavior: "smooth" });
  }
})((window.el.HistoryService = window.el.HistoryService || {}), jQuery);
